import React, { Component } from 'react';
import iconFacebook from '../images/iconFacebook.png'
import iconInstagram from '../images/iconInstagram.svg'
import iconTwitter from '../images/iconTwitter.svg'
import iconYoutube from '../images/iconYoutube.svg'
import Translator from './Translator/Translator';
import opportunityCentral from '../images/opportunityCentral.png';

export class Footer extends Component {

    constructor(props) {
		super(props);
		this.state = { showTranslator: false };
	}	

	render() {		
        return (
			<div className="footer">
				<nav className="navbar navbar-dark">
					<div className="container align-items-lg-stretch">						
						<img
							src={opportunityCentral}
							alt='Opportunity Central Logo'
							height='100px'
							className='mr-4 county-logo'
						/>			

						<ul className="navbar-nav" id="footer-nav-menu">
							<li className="nav-item"><a href="https://stlouiscountymo.gov/st-louis-county-departments">Departments</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/st-louis-county-government">Government</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/services">Services</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.govst-louis-county-public-notices/">Public Notices</a></li>
						</ul>

						<ul className="navbar-nav" id="footer-nav-quick-links">
							<li className="nav-item"><a href="https://stlouiscountymo.gov/contact-us">Contact Us</a></li>
							<li className="nav-item"><a href="https://www.governmentjobs.com/careers/stlouis">Careers</a></li>
							<li className="nav-item"><a href="https://recordsrequest.stlouiscountymo.gov/">Sunshine Requests</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/online-payments-and-forms/">Payments &amp; Forms</a></li>
						</ul>

						<ul className="navbar-nav" id="footer-nav-other">
							<li className="nav-item"><a href="https://stlouiscountymo.gov/st-louis-county-departments/administration/personnel/adadisabilities/">ADA Information</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/contact-us/privacy-policy">Privacy Policy</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/contact-us/terms-of-use">Terms of Use</a></li>
							<li className="nav-item"><a href="https://stlouiscountymo.gov/contact-us/sms-terms-of-use">SMS - Terms of Use</a></li>
						</ul>

						<ul className="navbar-nav" id="footer-translate-and-social-media">
							<li>
								<Translator />
							</li>
							<li className="nav-item mt-2 social-media">
								<div className="nav-item d-inline-block">
									<a href="https://www.facebook.com/stlcountymo/" target="_blank" rel="noopener noreferrer">
										<img alt="STLCO Facebook" src={iconFacebook} className="social-media-icons"/>
									</a>
								</div>
								<div className="nav-item d-inline-block">
									<a href="https://twitter.com/SaintLouCo" target="_blank" rel="noopener noreferrer">
										<img alt="STLCO Twitter" src={iconTwitter} className="social-media-icons"/>
									</a>
								</div>
								<div className="nav-item d-inline-block">
									<a href="https://www.instagram.com/stlouisco" target="_blank" rel="noopener noreferrer">
										<img alt="STLCO Instagram" src={iconInstagram} className="social-media-icons"/>
									</a>
								</div>
								<div className="nav-item d-inline-block">
									<a href="https://www.youtube.com/channel/UCg1pS5VLoFkPBcXR9Rjsd8Q" target="_blank" rel="noopener noreferrer">
										<img alt="STLCO YouTube" src={iconYoutube} className="social-media-icons"/>
									</a>
								</div>
							</li>
						</ul>
					</div>
				</nav>
			</div>
        );
    }
}
